import request from '@/utils/request3'
import store from '@/store'

const serviceName = store.state.serviceName.wflow

// 历史记录分页查询
// condition: { scope, flowKey, status, initiatorName, beginTime, endTime }
export function historyPage(data) {
  return request({ url: serviceName + `/wflow/history/page`, method: 'post', data })
}

// 历史记录导出（按当前查询条件导出全部匹配记录，返回文件流）
export function historyExport(data) {
  return request({ url: serviceName + `/wflow/history/export`, method: 'post', data, responseType: 'blob' })
}

// 当前用户可用的数据分类（我发起的 / 我审批的 / 抄送我的 / 全部）
export function historyScopes() {
  return request({ url: serviceName + `/wflow/history/scopes`, method: 'get' })
}

// 流程下拉数据：当前用户数据范围内「历史上出现过实例」的流程（含已停用；已删除流程定义聚合为一项）
export function historyFlows() {
  return request({ url: serviceName + `/wflow/history/flows`, method: 'get' })
}
